import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App.vue'
import router from './router'
import store from './store'
import jQuery from 'jquery'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

// アイコンをライブラリに追加
library.add(faInfoCircle);

// FontAwesomeIconコンポーネントをグローバルコンポーネントとして登録
Vue.component('font-awesome-icon', FontAwesomeIcon);

// BootstrapVueプラグインを使うようにVueに指示
Vue.use(BootstrapVue)
// オプショナル：BootstrapVueアイコンコンポーネントプラグインを使用する
Vue.use(IconsPlugin)

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'ja',
  messages: {
    ja: {
      change_locale: 'EN',
      logo_oures: {
        path: 'image/logo_oures_ja.png',
        alt: '大阪大学　研究者総覧'
      },
      search_by_keyword: 'キーワードで検索',
      how_to_use: '使い方',
      explanation_title: "キーワード検索について<br />",
      explanation: "・複数のキーワードで絞り込みたい場合は、スペースで区切って入力してください。<br />・検索方法の選択に応じて複数の文字で AND 検索もしくは OR検索が出来ます。<br />・スペースを含めた複数の文字列を１つの文字列としたい場合は、引用符「\"」（半角）で囲んでください。",
      and_search: 'AND',
      or_search: 'OR',
      search_by_name: '氏名で検索',
      search_by_field: '専門分野で検索',
      search_by_department: '所属で検索',
      search_researchers: '研究者を検索',
      filter_by: 'さらに研究者を検索',
      enter_keyword: 'キーワードで検索',
      enter_name: '氏名で検索',
      post: '職名',
      post_kyoju: '教授',
      post_junkyoju: '准教授',
      post_koshi: '講師',
      post_jokyo: '助教',
      post_sonota: 'その他',
      department: '所属',
      research_area: '専門分野',
      search: '検索',
      sort_by: '表示順',
      sort_by_name_asc: '名前（アーワ）',
      sort_by_name_desc: '名前（ワーア）',
      sort_by_department: '所属',
      sort_by_post: '職名',
      display_count: '表示件数',
      display_count_10: '10件',
      display_count_20: '20件',
      display_count_30: '30件',
      display_count_50: '50件',
      display_count_100: '100件',
      sort: '並び替え',
      search_result_1: '【検索結果】',
      search_result_2: '件中',
      search_result_3: '件目',
      dummy: 'aaa'
    },
    en: {
      change_locale: 'JA',
      logo_oures: {
        path: 'image/logo_oures_en.png',
        alt: 'Researcher Directory - Osaka University'
      },
      search_by_keyword: 'Search by Keyword',
      how_to_use: 'How To Use',
      "explanation_title": "About Search by Keyword<br />",
      "explanation": "・If you want to narrow down your search using multiple keywords, separate them with a space.<br />・Depending on the search method selected, you can perform an AND or OR search for multiple words.<br />・If you want to search for multiple words separated with spaces as a single string, enclose them with quotation marks, \" \" (single-byte character).",
      and_search: 'AND',
      or_search: 'OR',
      search_by_name: 'Search by Name',
      search_by_field: 'Search by Research Field',
      search_by_department: 'Search by Department',
      search_researchers: 'Researcher Search',
      filter_by: 'Filter by:',
      enter_keyword: 'Enter Keyword',
      enter_name: 'Search by Name',
      post: 'Title',
      post_kyoju: 'Professor',
      post_junkyoju: 'Associate Professor',
      post_koshi: 'Associate Professor (Lecturer)',
      post_jokyo: 'Assstant Professor',
      post_sonota: 'Others',
      department: 'Department',
      research_area: 'Research Field',
      search: 'Search',
      sort_by: 'Order by',
      sort_by_name_asc: 'Alphabetically (Ascending)',
      sort_by_name_desc: 'Alphabetically (Descending)',
      sort_by_department: 'Department',
      sort_by_post: 'Title',
      display_count: 'Results per page',
      display_count_10: '10',
      display_count_20: '20',
      display_count_30: '30',
      display_count_50: '50',
      display_count_100: '100',
      sort: 'Sort',
      search_result_1: 'Search Results: ',
      search_result_2: '  results: ',
      search_result_3: '',
      dummy: 'bbb'
    }
  }
})

global.jquery = jQuery
global.$ = jQuery
window.$ = window.jQuery = require('jquery')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n: i18n,
  render: h => h(App)
}).$mount('#app')
